<template>
  <section class="container-fluid pattern-bg -woven_dark py-5 py-md-7">
    <div class="row d-flex align-items-center animate -sequence">
      <div
        class="col-12 col-md-5 pl-md-0 mb-3 mb-md-0 anim-el"
        data-anim-order="1"
        data-anim-type="slide-right"
      >
        <div class="image-container -square_image" id="hp-services-1"></div>
      </div>
      <div
        class="col-12 offset-md-1 col-md-5 anim-el"
        data-anim-order="2"
        data-anim-type="slide-right"
      >
        <h2 class="white-text">Independent Financial Advisory</h2>
        <h3 class="subhead gold-text mb-4">
          Sector Focused. Relationship Driven.
        </h3>
        <p>
          CS Capital Advisors provides corporate advisory, mergers &amp;
          acquisitions, capital raising and restructuring services to the health
          care, hospitality and other commercial real estate industries and
          related service sectors. CSCA is one of the leading financial advisors
          to the senior housing, skilled nursing and related senior care
          industries with an unparalleled transactions track record and network
          of industry relationships.
        </p>
        <p>
          Our history is deeply rooted in real estate given our early beginnings
          as the investment banking subsidiary of Cohen &amp; Steers, Inc.
          (NYSE:CNS) from 1999 to 2009.
        </p>
        <p class="mb-5">
          With a proven long-term track record and creative approach to complex
          situations, we are the trusted adviser of choice to public and private
          company senior executives, boards and independent committees.
        </p>
        <router-link
          :to="{ name: 'Financial-Advisory' }"
          class="btn -hollow_white"
          >Learn More</router-link
        >
      </div>
    </div>
    <div class="row mt-7 d-flex align-items-center animate -sequence">
      <div
        class="col-12 offset-md-1 col-md-5 anim-el"
        data-anim-order="2"
        data-anim-type="slide-left"
      >
        <h2 class="white-text">
          Dedicated Asset Management and Consulting Services
        </h2>
        <h3 class="subhead gold-text mb-4">
          Result Driven. Hands-On Approach.
        </h3>
        <p class="mb-5">
          CS Capital Advisors provides focused asset management and consulting
          services to investors and operators. Our talented team brings a
          combination of operational and transactional experience managing and
          advising on all aspects of senior housing operations to maximize value
          creation for our relationship clients.
        </p>
        <router-link
          :to="{ name: 'Asset-Management' }"
          class="btn -hollow_white"
          >Learn More</router-link
        >
      </div>
      <div
        class="col-12 order-first order-md-last order-md-2 offset-md-1 col-md-5 mb-3 mb-md-0 pr-md-0 anim-el"
        data-anim-order="1"
        data-anim-type="slide-left"
      >
        <div class="image-container -square_image" id="hp-services-2"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 0.5rem;
}
p {
  color: #ffffff;
}
#hp-services-1 {
  background-image: url(../assets/hp-service-1.jpg);
}
#hp-services-2 {
  background-image: url(../assets/hp-service-2.jpg);
}
</style>
